module.exports = __webpack_public_path__ + "img/geschmiedetesgelaender.c585d937.jpg";